import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SECURITY_CONFIG } from '../config/app.config';
import { environment } from '../../../environments/environment';

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (!SECURITY_CONFIG.enableCSRF) return next.handle(req);
    if (!this.isApiRequest(req.url)) return next.handle(req);
    if (!this.isStateChangingMethod(req.method)) return next.handle(req);
    if (req.headers.has(SECURITY_CONFIG.csrfHeaderName)) {
      return next.handle(req);
    }

    const token = this.getTokenFromMeta();
    if (!token) return next.handle(req);

    return next.handle(
      req.clone({
        setHeaders: { [SECURITY_CONFIG.csrfHeaderName]: token },
      }),
    );
  }

  private isStateChangingMethod(method: string): boolean {
    const m = method.toUpperCase();
    return m === 'POST' || m === 'PUT' || m === 'PATCH' || m === 'DELETE';
  }

  private isApiRequest(url: string): boolean {
    if (!url) return false;
    if (this.isRelativeUrl(url)) return true;

    const base = (environment.baseURL || '').trim().replace(/\/+$/, '');
    if (!base) return false;
    return url.startsWith(base);
  }

  private isRelativeUrl(url: string): boolean {
    return !/^https?:\/\//i.test(url);
  }

  private getTokenFromMeta(): string | null {
    const meta = document.querySelector(
      `meta[name="${SECURITY_CONFIG.csrfMetaTagName}"]`,
    );
    const content = meta?.getAttribute('content');
    return content ? content.trim() : null;
  }

}
